import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import { ContatoForm } from '../../components/Contato';
import Logo from '../../components/Logo';
import { PlanoList, PlanoContextProvider } from '../../components/Plano';
import TituloText from '../../components/TituloText';
import planos from '../../data/planos.json';
import Plano from '../../interfaces/Plano';

import Wab from './components/Wab';
import {
  Menu, // eslint-disable-line @typescript-eslint/no-unused-vars
  MenuMobile, // eslint-disable-line @typescript-eslint/no-unused-vars
  MenuSimpleItem,
  MenuSocialItem,
} from './components/Menu';
import Footer from './components/Footer';
import useStyles from './styles';
import Carousel from './components/Carousel'; // eslint-disable-line @typescript-eslint/no-unused-vars

const HomePage: React.FC<{}> = () => {
  const classes = useStyles();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const menuItems: MenuSimpleItem[] = [
    { label: 'Inicio', link: '' },
    { label: 'Planos', link: '#planos' },
    { label: 'Contato', link: '#contato' },
  ];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const socialItems: MenuSocialItem[] = [
    { type: 'fb', link: '' },
    { type: 'ig', link: '' },
  ];

  const planosList = <PlanoList planos={ planos as Plano[] }/>;

  return (<>
    <header className={ classes.header }>
      <Container>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={ classes.navbar }
        >
          <Grid item xs={10} sm={6} md={3}>
            <Logo className={ classes.logo } />
          </Grid>
          <Grid item className={ classes.menu } md={9}>
            {/* <Menu items={ menuItems } social={ socialItems } /> */}
          </Grid>
          <Grid item className={ classes.menuMobile }>
            {/* <MenuMobile items={ menuItems } /> */}
          </Grid>
        </Grid>
      </Container>
    </header>
    {/* <Carousel /> */}
    <main className={ classes.main }>
      <PlanoContextProvider>
        <section id='planos' className={ classes.mainSection }>
          <TituloText>Planos</TituloText>
          <Container>{ planosList }</Container>
        </section>
        <section  id='contato' className={ classes.mainSection }>
          <TituloText>Contato</TituloText>
          <Container>
            <ContatoForm />
          </Container>
        </section>
      </PlanoContextProvider>
      <Wab />
    </main>
    <Footer />
  </>);
};

export default HomePage;